<template>
  <div class=" mt-3">
    <div class="col-12">
      <div class="row">
        <div class="col-6 form-group">
          <select class="form-control" v-model="city">
            <option value="tehran">تهران</option>
            <option value="other">شهرستان</option>
            <option value="all">همه</option>
          </select>
        </div>
        <div class="col-6 form-group">
          <button class="btn btn-primary text-white">
            <router-link :to="{name :'major'}" class="text-white">سفارشات عمده</router-link>
          </button>
          <!--                    <select class="form-control" v-model="status">-->
          <!--                        <option value="wc-temp-processing" selected >در حال پردازش</option>-->
          <!--                        <option value="wc-processing">در حال انجام</option>-->
          <!--                    </select>-->
        </div>
        <div class="col-7 direction-ltr">
          <paginate
              :page-count="lastPage"
              :click-handler="changePage"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :page-range="1"
              :margin-pages="1">
          </paginate>
        </div>
        <div class="col-12 form-group">
          <div class="row">
            <input type="text" class="col-8 form-control" placeholder="شناسه سفارش یا شماره تلفن"
                   v-model="search">
            <div class="col-4">
              <div class="w-100 btn btn-primary " @click="searchOrder">جستجو</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="">
      <div id="accordion" style="position: static">
        <div class="card soft-shadow mt-3 order-border" v-for="order in orders" :key="order.id">
          <div class="card-header" :id="'heading'+order.id">
            <h5 class="mb-0">
              <div class="row text-center d-flex justify-content-center">
                <div class="col-12">
                  <div class="row">
                    <div class="col-6 text-primary font-weight-bold"><span>#{{ order.id }}</span>
                    </div>
                    <div class="col-6"><span>{{ order.customer_name }}</span></div>
                  </div>
                </div>
                <div class="col-12 mt-2">
                  <div class="row">
                    <div class="col-6"><span>{{ numberWithCommas(order.price) }}</span>
                      <span>تومان</span></div>
                    <div class="col-6"><span>{{ order.shipping }}</span></div>
                  </div>
                </div>
              </div>
              <hr class="w-100 mb-1">
              <button class="btn btn-link m-0 p-0 col-12" data-toggle="collapse"
                      v-bind:data-target="'#collapse'+order.id"
                      aria-expanded="true" v-bind:aria-controls="'collapse' + order.id">
                <span><i class="fa fa-caret-down" style="font-size: 1.2rem"></i></span>
              </button>
            </h5>
          </div>

          <div :id="'collapse' + order.id" class="collapse show"
               v-bind:aria-labelledby="'heading' + order.id" data-parent="">
            <div class="card-body">
              <div class="row">
                <div class="col-12 text-right text-danger border-bottom pb-2 mb-2"
                     style="font-size: 1.2rem">
                  شماره تلفن : {{ order.phone }}
                </div>
                <!--   items section   -->
                <div class="col-12 products" v-for="item in order.items" :key="item.id">
                  <div class="row">

                    <div class="col-3 p-0">
                      <img :src="item.image"
                           class="w-100" alt="">
                    </div>
                    <div class="col-5 text-right">
                      <div class="col-12">#{{ item.id }}</div>
                      <div class="col-12">{{ item.title }}</div>
                    </div>
                    <div class="col-4">
                      <div class="row">
                        <div class="col-12 text-danger" style="font-weight: 800;font-size: 1.7rem">
                          <b class=" ">{{ item.quantity }}</b> عدد
                        </div>
                        <div class="col-12 font-weight-bold" style="font-weight: 600;font-size: 1.2rem">
                          {{ numberWithCommas(item.price) }}
                        </div>
                        <div class="col-12">
                          <input type="number" :id="'buy_price' + order.id + '_' + item.id"
                                 class="form-control form-group text-left direction-ltr" :value="item.buy_price">
                          <div class="row">
                            <div class="col-12">
                              <button class="btn btn-success col-12" @click="addBuyPrice(item.id, order.id)">خرید
                              </button>
                            </div>
                            <div class="col-12 mt-2">
                              <button class="btn btn-primary col-12 font-1-rem" :class="from_stock_class(item)"
                                      @click="addFromStock(item, order.id )"><span>انبار</span>
                              </button>
                            </div>
                            <div class="col-12 mt-2">
                              <button class="btn btn-warning col-12 font-1-rem" :class="cancelled_class(item)"
                                      @click="setCancelled(item, order.id )"><span>لغو</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--  notes section -->
              <div class="row mt-2">
                <p class="col-12">یادداشت ها</p>
                <div class="col-12" v-for="note in order.notes" :key="note.id">
                  <div class="col-12 order-note" v-bind:class="{'bg-danger': AddedByUser(note)}"
                       v-if="AddedByUser(note)">
                    <div class="">
                      {{ note.content }}
                    </div>
                  </div>

                </div>
                <div class="col-12">
                  <div class="col-12 order-note bg-primary text-white"
                       v-if="order.customer_note.length > 0">
                    <div class="">
                      {{ order.customer_note }}
                    </div>
                  </div>

                </div>
                <div class="col-12 form-group">
                  <div class="row">
                    <div class="col-10">
                                            <textarea class="col-12 form-control" placeholder="یادداشت جدید"
                                                      v-model="order.newNote"></textarea>
                    </div>
                    <div class="col-2 btn btn-primary" @click="addNote(order.id)"
                         style="max-height: 35px">ثبت
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-9 form-group">
                      <select class="form-control" v-model="order.status">
                        <option v-for="status in statuses" :key="status.value"
                                :value="status.value">{{ status.title }}
                        </option>
                      </select>
                    </div>
                    <div class="col-2 btn btn-primary" @click="changeStatus(order.id)"
                         style="max-height: 35px">ثبت
                    </div>

                    <div class="col-12 mt-2 padding">
                      <div class="btn btn-primary" @click="print('print'+ order.id)">چاپ</div>
                      <div :id="'print'+ order.id" class="d-none">
                        <div class="content factor">
                          <div class="ticket-image"
                               style="background-image: url('http://amirtorkaman.ir/ticket-image.png')"></div>
                          <table>
                            <tr>
                              <th width="50%">سفارش {{ order.id }}
                              </th>
                              <th width="50%">فرستنده</th>
                            </tr>
                            <tr>
                              <td rowspan="3">
                                <div style="text-align: center;">
                                  <img src="https://cdn1.farskala.ir/2020/01/logoooo.png"
                                       alt=" ">
                                </div>
                                <br>
                                <table id="data">
                                  <tr>
                                    <td><b>شیوه ارسال</b></td>
                                    <td>{{ order.shipping_method }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td><b>زمان ارسال</b></td>
                                    <td>{{ order.date }}</td>
                                  </tr>
                                  <tr>
                                    <td><b>روش پرداخت</b></td>
                                    <td>{{ order.payment_method }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td><b>مبلغ کل</b></td>
                                    <td>{{ order.price }} تومان</td>
                                  </tr>
                                </table>
                              </td>
                              <td>
                                <p><b>فرستنده: </b>{{ sender.name }}</p>
                                <p><b>نشانی: </b>{{ sender.state }} {{ sender.city }}
                                  {{ sender.address }}</p>
                                <p><b>کد پستی: </b>{{ sender.postcode }}</p>
                                <p><b>تلفن: </b>{{ sender.phone }}</p>

                              </td>
                            </tr>
                            <tr>
                              <th width="50%">گیرنده</th>
                            </tr>
                            <tr>
                              <td>
                                <p>
                                  <b>گیرنده: </b>
                                  {{ order.customer_name }}
                                </p>
                                <p>
                                  <b>نشانی: </b>
                                  {{ order.shipping }} - {{ order.address }}
                                </p>
                                <p>
                                  <b>کد پستی: </b>{{ order.postcode }}
                                </p>
                                <p>
                                  <b>شماره
                                    تماس: </b>{{ order.phone }}
                                </p>

                              </td>
                            </tr>

                          </table>
                          <div class="ticket-image"
                               style="background-image: url('http://amirtorkaman.ir/ticket-image.png')"></div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="vld-parent">
      <loading :active.sync="isLoading"
               :is-full-page="fullPage"></loading>
    </div>
    <div class="col-12 mt-4">
      <div class="btn btn-danger" @click="logout">خروج</div>
    </div>
  </div>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
import Paginate from 'vuejs-paginate'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "Index",

  data() {
    return {
      city: "tehran",
      page: 1,
      orders: [],
      statuses: [],
      count: 0,
      lastPage: 0,
      isLoading: true,
      fullPage: true,
      newNote: "",
      search: "",
      status: "wc-temp-processing",
      sender: {},
      counter: 0
    }
  },
  components: {
    Loading,
    Paginate
  },
  watch: {
    city: function () {
      this.page = 1;
      localStorage.setItem("fk_city", this.city);
      this.getOrders();
    },
    page: function () {
      localStorage.setItem("fk_page", this.page);
    }
  },
  mounted() {

    //check what was the last city and page
    let city = localStorage.getItem("fk_city");
    let page = localStorage.getItem("fk_page");

    if (city === null) {
      this.city = "tehran";
    } else {
      this.city = city;
    }
    localStorage.setItem("fk_city", this.city);

    if (page === null) {
      this.page = 1;
    } else {
      this.page = page;
    }
    localStorage.setItem("fk_page", this.page);


    this.checkToken();
    this.getOrders();
  },
  methods: {
    AddedByUser: function (note) {
      return note.added_by !== "system";
    },
    checkToken: function () {
      let token = localStorage.getItem('token');

      if (token === null) {
        this.$router.push({
          name: "login"
        })
      }

      this.axios.get(this.$hostname + "token", this.$header).then(response => {

        if (!response.data.success) {
          this.$router.push({
            name: "login"
          })
        }

      }).catch(() => {
        this.$router.push({
          name: "login"
        })
      })
    },
    getOrders: function () {

      this.isLoading = true;

      let Data = {
        city: this.city,
        page: this.page,
        search: this.search,
        status: this.status
      };

      this.axios.post(this.$hostname + "orders", Data, this.$header).then(response => {
        this.orders = response.data.data.orders;
        this.count = response.data.data.count;
        this.lastPage = response.data.data.last_page;
        this.statuses = response.data.data.statuses;
        this.sender = response.data.data.sender;

        this.isLoading = false;

      }).catch(error => {
        this.isLoading = false
        alert(error.response);
      });
    },
    changePage: function (pageNum) {
      this.page = pageNum;
      this.getOrders();
    },
    addNote: function (order_id) {
      this.isLoading = true;

      let order = this.orders.find(x => x.id === order_id);
      let newNote = order.newNote;

      let Data = {
        note: newNote
      }

      this.axios.post(this.$hostname + "order/note/" + order_id, Data, this.$header).then(response => {

        this.isLoading = false;
        if (!response.data.success) {
          alert(response.data.message);
          return false;
        }

        order.notes.push(response.data.data);

        order.newNote = "";

      }).catch(error => {
        this.isLoading = false;
        console.log(error.response);
      })
    },
    changeStatus: function (order_id) {

      this.isLoading = true;

      let order = this.orders.find(x => x.id === order_id);
      let Data = {
        status: order.status
      };

      this.axios.post(this.$hostname + "order/" + order_id, Data, this.$header).then(response => {

        this.isLoading = false;
        alert(response.data.message);

      }).catch(error => {

        this.isLoading = false;
        console.log(error.response);
      })
    },
    logout: function () {

      this.$swal({
        title: 'آیا میخواهید خارج شوید؟',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `بله`,
        cancelButtonText: `بازگشت`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {

          localStorage.removeItem("token")

          this.$router.push({
            name: "login"
          });

        }
      });
    },
    numberWithCommas: function (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    searchOrder() {

      if (this.search !== "") {
        this.status = "all";
      }

      this.getOrders();

    },
    print: function (id) {
      this.$htmlToPaper(id, null, () => {

      })
    },
    addBuyPrice: function (product_id, order_id) {
      // this.isLoading = true;

      const price = document.getElementById("buy_price" + order_id + "_" + product_id).value;
      if (!price || price === "") {
        alert("قیمت خرید را وارد کنید.")
        return false;
      }

      let Data = {
        product_id: product_id,
        price: price
      };

      this.axios.post(this.$hostname + "order/buy_price/" + order_id, Data, this.$header).then(response => {

        this.isLoading = false;
        if (!response.data.success) {
          alert(response.data.message);
          return false;
        }
      }).catch(error => {
        this.isLoading = false;
        console.log(error.response);
      })
    },
    addFromStock: function (item, order_id) {
      // this.isLoading = true;

      const product_id = item.id;
      let Data = {
        product_id: product_id,
      };

      this.axios.post(this.$hostname + "order/from_stock/" + order_id, Data, this.$header).then(response => {

        this.isLoading = false;
        if (!response.data.success) {
          alert(response.data.message);
          return false;
        }

        item.from_stock = response.data.data.toggle;

      }).catch(error => {
        this.isLoading = false;
        console.log(error.response);
      })
    },
    setCancelled: function (item, order_id) {
      // this.isLoading = true;

      const product_id = item.id;
      let Data = {
        product_id: product_id,
      };

      this.axios.post(this.$hostname + "order/cancel/" + order_id, Data, this.$header).then(response => {

        this.isLoading = false;
        if (!response.data.success) {
          alert(response.data.message);
          return false;
        }

        item.is_cancelled = response.data.data.toggle;

      }).catch(error => {
        this.isLoading = false;
        console.log(error.response);
      })
    },
    from_stock_class: function (item) {
      return item.from_stock ? "btn-danger" : "";
    },
    cancelled_class: function (item) {
      return item.is_cancelled ? "btn-danger" : "";
    }
  }
}
</script>

<style scoped>
.btn-link {
  color: #000000;
}

.btn-link.focus, .btn-link:focus {
  text-decoration: none;
}

.btn.focus, .btn:focus {
  box-shadow: none;
}

.btn:hover {
  text-decoration: none;
}

.accordion div {
  position: static;
}

.card {
  background-color: #fff;
}

#accordion h5 {
  font-size: 1rem;
}

.products {
  padding-bottom: 5px;
  padding-top: 6px;
  border-bottom: 1px solid rgba(86, 86, 86, 0.15);
}

.order-note {
  border-radius: 10px;
  background-color: #BDF9C9;
  color: #000000;
  padding: 10px;
  font-size: .7rem;
  text-align: right;
  margin-bottom: 5px;
}


</style>